// extracted by mini-css-extract-plugin
export default {"textButton":"textButton__TextButton__6q7jm","disabled":"disabled__TextButton__6q7jm"};